import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Form } from 'react-bootstrap';
import envConfig from '../../../../envConfig';
import ChannelSelectorModal from '../channelwidget/ChannelSelectorModal';

const HEAT_INDEX_CHANNELS_URL = `${envConfig.apiUrl}/api/v1/widget-data/heat-index/channels`;

const HeatIndexGaugeWidgetEdit = ({ context, onChange }) => {
  const { channelId = '', channelLabel = '' } = context;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleSelectChannel = ({ raw, row }) => {
    const label = [
      row.deviceName,
      row.sensorName,
      row.componentName,
      'Heat Index Channel',
    ].filter(Boolean).join(' | ');

    onChange({
      ...context,
      channelId: raw.channelId != null ? String(raw.channelId) : '',
      channelLabel: label,
    });
    setIsModalOpen(false);
  };

  // channelLabel is stored as a pipe-delimited string; split it back into
  // parts so we can render each with a dot separator between them.
  const labelParts = (channelLabel || '')
    .split('|')
    .map((s) => s.trim())
    .filter(Boolean);
  // eslint-disable-next-line no-nested-ternary
  const parts = labelParts.length > 0
    ? labelParts
    : (channelId ? [`Heat Index Channel ${channelId}`] : []);

  return (
    <Form.Group>
      <Form.Label>Channel</Form.Label>

      {channelId ? (
        <div className="d-flex align-items-center border rounded bg-white px-3 py-2">
          <div
            className="d-flex flex-wrap align-items-baseline flex-grow-1 mr-3"
            style={{ minWidth: 0, gap: '6px 10px' }}
          >
            {parts.map((text, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <React.Fragment key={i}>
                {i > 0 && <span className="text-muted small" aria-hidden="true">•</span>}
                <span className="text-truncate" title={text}>{text}</span>
              </React.Fragment>
            ))}
          </div>
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={() => setIsModalOpen(true)}
          >
            Change Channel
          </Button>
        </div>
      ) : (
        <div className="d-flex align-items-center justify-content-between border rounded bg-light px-3 py-2">
          <span className="text-muted small">No channel selected</span>
          <Button
            variant="primary"
            size="sm"
            onClick={() => setIsModalOpen(true)}
          >
            Select Channel
          </Button>
        </div>
      )}

      {!channelId && (
        <Form.Text className="text-danger">Must select a channel.</Form.Text>
      )}

      <ChannelSelectorModal
        show={isModalOpen}
        onHide={() => setIsModalOpen(false)}
        selectedChannelId={channelId}
        onSelectChannel={handleSelectChannel}
        title="Select a Heat Index Channel"
        hideChannelTypeSelector
        endpointUrl={HEAT_INDEX_CHANNELS_URL}
      />
    </Form.Group>
  );
};

HeatIndexGaugeWidgetEdit.propTypes = {
  context: PropTypes.shape({
    channelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    channelLabel: PropTypes.string,
  }),
  onChange: PropTypes.func,
};

HeatIndexGaugeWidgetEdit.defaultProps = {
  context: {},
  onChange: () => {},
};

export default HeatIndexGaugeWidgetEdit;
